import getScrollBarWidth from '../utils/getScrollBarWidth'

export default class Sidebar {
  constructor() {
    this.DOM = {}

    this.init()
  }

  init() {
    this.cacheSelectors()
    this.bindEvents()
  }

  cacheSelectors() {
    this.DOM.$body = $('body')
    this.DOM.$sidebar = $('.js-sidebar')
  }

  bindEvents() {
    const self = this
    this.DOM.$body.on('click', '.js-sidebarLink', (e) => {
      const currentTarget = $(e.currentTarget)
      const sidebarId = currentTarget.data('sidebar-id')

      this.sidebarOpen(sidebarId)
    })
    this.DOM.$body.on('click', '.js-sidebarClose', () => this.sidebarClose())
    window.$sidebarOpen = function(sidebarId) {
      self.sidebarOpen(sidebarId)
    }
  }

  sidebarOpen(sidebarId) {
    const sidebar = $(`${sidebarId}`)

    sidebar.addClass('is_open')
    this.DOM.$body.addClass('is-sidebar-open')
    // this.DOM.$body.css('margin-right', scrollBarWidth)

    setTimeout(() => {
      sidebar.addClass('is_visible')
    }, 33)
  }

  sidebarClose() {
    const self = this

    self.DOM.$sidebar.removeClass('is_visible')
    self.DOM.$sidebar.find('.datepicker-inline').removeClass('active');
    self.DOM.$sidebar.find('.datepicker').removeClass('active');

    setTimeout(() => {
      self.DOM.$sidebar.removeClass('is_open')
      self.DOM.$body.removeClass('is-sidebar-open')
      // self.DOM.$body.css('margin-right', '')
    }, 300)
  }
}
